import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    primary: '#455a64',
    secondary: '#ff4081',
    lprimary: '#718792',
    lsecondary: '#ff79b0',
    dprimary: '#1c313a',
    dsecondary: '#c60055',
    lightgray: '#F5F5F6',
    darkgray: '#E1E2E1',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  icons: {
    iconfont: 'md',
  }
}

export default new Vuetify(opts)